<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction>
        <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="XMLButtonClicked()">
              <i class="fas fa-upload mr-2"></i>
              {{$helper.getWord('Publish')}}
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="viewButtonClicked()">
              <i class="far fa-eye mr-2"></i>
              {{$helper.getWord('View')}}
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button
              type="button"
              class="btn btn-primary legitRipple"
              @click="ReviseButtonClicked()"
            >
              <i class="fas fa-pen mr-2"></i>
              {{$helper.getWord('Revise')}}
            </button>
          </div>
          <!-- <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="saveButtonClicked()">
              <i class="icon-floppy-disk mr-2"></i>Save
            </button>
          </div>-->
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-light legitRipple" @click="cancelBtnClick()">
              <i class="far fa-window-close mr-2"></i>
              {{$helper.getWord('cancel')}}
            </button>
          </div>
        </template>
      </PageHeaderNoAction>
      <div class="section-body">
        <DataFilter
          :gridId="gridId"
          :isExport="false"
          :hasNew="true"
          newLink="/Builder/Workflow/New"
        ></DataFilter>
        <SlickGrid
          :gridId="gridId"
          :editable="false"
          :frozenColumn="2"
          :isAutoInitData="true"
          :isModeManager="true"
          :baseUrl="baseUrl"
        />
        <div ref="fullScreenDialog" class="modal" role="dialog">
          <div class="modal-dialog" role="document" style="max-width:100%;height:100%;">
            <div class="modal-content" style="width:100%;height:100%">
              <div class="modal-header">
                <h5 class="modal-title">{{isView?"Workflow viewer":"Workflow editor"}}</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="closeModal()"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <iframe
                  v-if="requestID"
                  :src="link"
                  style="width:100%;height:100%"
                >Your browser doesn't support iframes</iframe>
              </div>
            </div>
          </div>
        </div>

        <!--   <iframe :src="link" title="W3Schools Free Online Web Tutorials"></iframe>-->
      </div>
    </section>
  </div>
</template>


<script>
import api from "@/api";
import config from "@/config";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";

export default {
  title: "Sys Workflow Header",
  access_code: "G_WF01",
  icon: "fas fa-code-branch fa-fw",
  order: 8,
  components: {},
  data() {
    return {
      gridId: "wf01",
      formData: {
        staff_name: ""
      },
      baseUrl: "/workflow",
      requestID: null,
      isView: false
    };
  },
  created() {
    ////this.$route.meta.access_code = this.gridId;
  },
  computed: {
    ...mapGetters("grid", ["getGridById"]),

    grid() {
      return _.cloneDeep(this.getGridById(this.gridId));
    },
    mode() {
      return this.grid.mode;
    },
    dataList() {
      return this.grid.selectRows || [];
    },
    link() {
      if (this.dataList.length > 0)
        if (this.isView) {
          return (
            config.serverBase +
            "/grapheditor.html?requestID=" +
            this.requestID +
            "&chrome=0"
          );
        } else {
          return (
            config.serverBase + "/grapheditor.html?requestID=" + this.requestID
          );
        }
    }
  },
  mounted() {},
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest"
    ]),

    request() {
      return new Promise((resolve, reject) => {
        if (this.dataList.length > 1) {
          helper.alert("only can select one");
          resolve(false);
          return;
        }
        this.requestID = null;
        helper.loading();
        // let copyForm = _.cloneDeep(this.formData);
        // helper.join(copyForm, "declare");
        api.request(
          this,
          "post",
          `${this.baseUrl}/${this.gridId}_request`,
          {
            SessionID: helper.getSessionID(),
            LocaleCode: helper.getLocaleCode(),
            //LocaleCode: this.$store.state.user.locale_code,
            Parameters: {
              id: this.$route.params.id,
              dataList: this.dataList,
              mode: this.mode
            }
          },
          function(r) {
            // helper.clearData(this);
            // helper.findNow(this);
            helper.done();
            this.requestID = r.data.requestID;
            resolve(true);
          },
          function(r) {
            resolve(false);
            helper.done();
          },
          null
        );
      });
    },
    async saveButtonClicked() {
      this.isView = false
      await this.request();
      helper.showModal(this.$refs.fullScreenDialog);
      // window.open(this.link, "_blank");
      // this.$router.go(-1);
    },

    cancelBtnClick() {
      this.$router.go(-1);
    },
    ReviseButtonClicked() {
      // console.log(this.dataList);
      if (this.dataList.length == 1) {
        this.saveButtonClicked();
      } else {
        helper.alert("only can select one");
        return;
      }
    },
    async viewButtonClicked() {
      this.isView = true;
      await this.request();
      helper.showModal(this.$refs.fullScreenDialog);
      // window.open(this.link + "&chrome=0", "_blank");
    },
    closeModal() {
      if (!this.isView) {
        this.requestID = null;
        helper.hideModal(this.$refs.fullScreenDialog);
        helper.findNow(this);
      }
    },
    XMLButtonClicked() {
      console.log(this.dataList);
      if (this.dataList.length == 1) {
        // var wfdataraw = Graph.decompress(this.dataList[0].wfdesigner);
        helper.loading();
        api.request(
          this,
          "post",
          `${this.baseUrl}/${this.gridId}_XMLToSQL`,
          {
            SessionID: helper.getSessionID(),
            LocaleCode: helper.getLocaleCode(),
            //LocaleCode: this.$store.state.user.locale_code,
            Parameters: {
              id: this.$route.params.id,
              dataList: this.dataList,
              // xmlfile: wfdataraw,
              mode: this.mode
            }
          },
          function(r) {
            helper.clearData(this);
            helper.findNow(this);
            helper.done();
          },
          function(r) {
            helper.done();
          },
          null
        );
      }
    }
  }
};
</script>


